import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import 'vuetify/styles'
import './assets/theme.css'

createApp(App).use(vuetify).use(router).mount('#app')
